var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"website_container"},[_c('div',{staticClass:"website_content clearfix"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":_vm.contentImg,"alt":"content"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }